export const MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
export const InternalSubscriptionNames = {
  ONE_TO_ONE: 'ONE_TO_ONE',
  MARKETING_INFORMATION: 'MARKETING_INFORMATION',
  SERVICE_HUB_FEEDBACK: 'SERVICE_HUB_FEEDBACK'
};
export const UnsubscribeStatuses = {
  NOT_STARTED: 'NOT_STARTED',
  PENDING: 'PENDING',
  WRONG_EMAIL: 'WRONG_EMAIL',
  INVALID_PRODUCT: 'INVALID_PRODUCT',
  USER_ERROR: 'USER_ERROR',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  REDIRECT: 'REDIRECT',
  SUCCESS_UNSUB_ALL: 'SUCCESS_UNSUB_ALL'
};
export const ProductTypes = {
  LEAD_FLOWS: 'leadFlows',
  SALES: 'sales',
  STARTER: 'emailStarter',
  FEEDBACK: 'feedback'
};